import URI from 'urijs';

import Client, { jsonapi, statusOK, authorize } from '@occc-app/lib/client';

type ApiMethod = (path: string, body?: object, params?: object) => Promise<object>;

type ApiPostMethod = (
  path: string,
  body: string | RequestInit['body'] | object,
  params?: object,
) => Promise<object>;

export class CoreApi {
  audiences = {
    id: (id: string) => ({
      show: (params: object) => this.get(`/api/v2/audiences/${id}`, params),
    }),
  };

  constraints = {
    id: (id: string) => ({
      show: (params: object) => this.get(`/api/v2/constraints/${id}`, params),
    }),
  };

  csvUploads = {
    index: (params: object) => this.get('/api/v2/csv_uploads', params),
    create: (body: object, params: object) => this.post('/api/v2/csv_uploads', body, params),
    id: (id: string) => ({
      show: (params: object) => this.get(`/api/v2/csv_uploads/${id}`, params),
    }),
  };

  earningMechanisms = {
    id: (id: string) => ({
      show: (params: object) => this.get(`/api/v2/earning_mechanisms/${id}`, params),
    }),
  };

  limits = {
    id: (id: string) => ({
      show: (params: object) => this.get(`/api/v2/limits/${id}`, params),
    }),
  };

  marketingContents = {
    id: (id: string) => ({
      show: (params: object) => this.get(`/api/v2/marketing_contents/${id}`, params),
    }),
  };

  offers = {
    // TODO Revisit the type definition... this is a complex type.
    index: (params?: object) => this.get('/api/v2/offers', params),
    id: (id: string) => ({
      show: (params: object) => this.get(`/api/v2/offers/${id}`, params),
    }),
  };

  segments = {
    index: (params: object) => this.get('/api/v2/segments', params),
    create: (body: object, params: object) => this.post('/api/v2/segments', body, params),
    id: (id: string) => ({
      patch: (body: object) => this.patch(`/api/v2/segments/${id}`, body),
      show: (params: object) => this.get(`/api/v2/segments/${id}`, params),
      delete: (params: object) => this.delete(`/api/v2/segments/${id}`, params),
    }),
  };

  private baseClient: Client;
  private get: ApiMethod;
  private post: ApiPostMethod;
  private patch: ApiMethod;
  private delete: ApiMethod;

  constructor(host: string, accessToken: string) {
    this.baseClient = new Client(URI(host))
      .req(jsonapi())
      .req(authorize(accessToken))
      .res(statusOK())
      .res(jsonapi());
    this.get = this.baseClient.get;
    this.post = this.baseClient.post;
    this.patch = this.baseClient.patch;
    this.delete = this.baseClient.delete;
  }
}

let singleton: CoreApi;

export const setupSingleton = (host: string, accessToken: string, klass = CoreApi) =>
  (singleton = new klass(host, accessToken));
export const setSingleton = (instance: CoreApi) => (singleton = instance);
export const getSingleton = () => singleton;
